export const PERSONAL_DATA_CATEGORY_OPTIONS = [
  { title: 'Personal', value: 'Personal' },
  { title: 'Sensitive', value: 'Sensitive' },
  { title: 'Non-Personal', value: 'Non-Personal' },
]
